var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4986 0.239319C5.14913 0.239319 0 5.40857 0 11.7853C0 16.8856 3.29475 21.2124 7.866 22.7405C8.441 22.8469 8.65088 22.4904 8.65088 22.1842C8.65088 21.9096 8.64081 21.1837 8.63506 20.2206C5.43663 20.9178 4.761 18.6724 4.761 18.6724C4.23919 17.3384 3.4845 16.9833 3.4845 16.9833C2.43944 16.2674 3.56212 16.2818 3.56212 16.2818C4.71644 16.3638 5.32306 17.4721 5.32306 17.4721C6.34944 19.2359 8.0155 18.727 8.671 18.4309C8.7745 17.6848 9.07206 17.1759 9.40125 16.887C6.84825 16.5952 4.163 15.6048 4.163 11.1816C4.163 9.92088 4.6115 8.89019 5.3475 8.08232C5.22819 7.79051 4.83431 6.61607 5.45963 5.02763C5.45963 5.02763 6.42563 4.71713 8.62213 6.21069C9.53925 5.95482 10.5225 5.82688 11.5014 5.82257C12.4775 5.82832 13.4622 5.95482 14.3807 6.21213C16.5758 4.71857 17.5404 5.02907 17.5404 5.02907C18.1671 6.61894 17.7732 7.79194 17.6554 8.08376C18.3928 8.89163 18.837 9.92232 18.837 11.183C18.837 15.6177 16.1489 16.5938 13.5872 16.8798C13.9998 17.2363 14.3678 17.9407 14.3678 19.0174C14.3678 20.5613 14.3534 21.8061 14.3534 22.1842C14.3534 22.4933 14.5604 22.8526 15.1441 22.7391C19.7081 21.2096 23 16.8841 23 11.7853C23 5.40857 17.8509 0.239319 11.4986 0.239319Z",
    fill: "#5C6BC0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.ec2787ebc4b335199bad37081f55e6fa.svg";
export { ForwardRef as ReactComponent };